// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { boldB16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bold-b': IconBoldB;
    }
}

/**
 * The icon component for the 'boldB' icon
 */
export class IconBoldB extends Icon {
    public constructor() {
        super(boldB16X16);
    }
}

registerIcon('icon-bold-b', IconBoldB);
export const iconBoldBTag = 'nimble-icon-bold-b';
